// src/internal/get-full-api-url.ts
function getFullApiUrl(maybeUrl) {
  const base = (() => {
    var _a, _b;
    if (typeof window !== "undefined") {
      return window.location.origin;
    }
    if (typeof process !== "undefined" && ((_a = process == null ? void 0 : process.env) == null ? void 0 : _a.VERCEL_URL)) {
      return `https://${process.env.VERCEL_URL}`;
    }
    if ((_b = import.meta.env) == null ? void 0 : _b.VERCEL_URL) {
      return `https://${import.meta.env.VERCEL_URL}`;
    }
    return "http://localhost:3000";
  })();
  try {
    const url = new URL(maybeUrl ?? "/api/uploadthing", base);
    if (url.pathname === "/") {
      url.pathname = "/api/uploadthing";
    }
    return url;
  } catch (err) {
    throw new Error(
      `Failed to parse '${maybeUrl}' as a URL. Make sure it's a valid URL or path`
    );
  }
}

export {
  getFullApiUrl
};
//# sourceMappingURL=chunk-4PDGVH57.mjs.map